export default "<div fxFlexFill fxLayoutAlign=\"center center\">\n  <mat-card fxFlex=\"80\">\n    Ici les détails d'une partie\n  </mat-card>\n</div>\n"